<template>
    <div id="section-to-print" style="padding: 40px;">
      <h3 style="text-align:center; margin-top: 10px; margin-bottom: 20px; font-family: Khmer Os Moul, 'Hanuman-Regular'">ទម្រង់ស្នើរសុំទម្លាក់កម្ចី OD</h3>

      <table style="font-size; 14px;">
        <tbody>
          <tr>
            <td style="text-align: justify; white-space: break-spaces; line-height: 2.5">
              គោលបំណងទិញស្រូវប្រភេទ<b class="underline">{{ datas.trading_purpose_name }}</b>បរិមាណ<b class="underline">{{ datas.quantity | formatNumber }}</b>បរិមាណ<b class="underline">{{ datas.quantity | formatNumber }}</b>តម្លៃរាយពីកសិករ<b class="underline">{{ parseFloat(datas.cost) | formatNumber }}{{ getCurrencySymbol(datas.currency_code) }}</b>
              តម្លៃសរុប<b class="underline">{{ parseFloat(datas.drawdown_amount) | formatNumber }}{{ getCurrencySymbol(datas.currency_code) }}</b><b class="underline">{{ parseFloat(datas.drawdown_amount) | formatNumber }}{{ getCurrencySymbol(datas.currency_code) }}</b>តំបន់ឡើងស្រូវទុំ ឃុំ<b class="underline">{{datas.loading_commune_name}}</b>ស្រុក<b class="underline">{{datas.loading_district_name}}</b>ខេត្ត<b class="underline">{{datas.loading_province_name}}</b>
              កាលបរិច្ឆេទឡើងស្រូវ ថ្ងៃទីខែឆ្នាំ<b class="underline">{{datas.loading_date | dateFormat}}</b>លក់ទៅរោងម៉ាស៊ីនឈ្មោះ<b class="underline">{{datas.miller_name}}</b>
              ទីតាំងខេត្ត<b class="underline">{{datas.province_name}}</b>តម្លៃលក់រាយ<b class="underline">{{ parseFloat(datas.price) | formatNumber }}{{ getCurrencySymbol(datas.currency_code) }}</b>
              កាលបរិច្ឆេទប្រហាក់ប្រហែលក្នុងការទទួលបានការទួទាត់ថ្លៃស្រូវត្រឡប់ពីរោងម៉ាស៊ីន<b class="underline">{{datas.payment_date | dateFormat}}</b>
            </td>

          </tr>

          <tr>
            <td style="padding-top: 50px;">
              <div style="width: 50%; float: left; text-align: center">ស្នើរដោយ</div>
              <div style="width: 50%; float: right; text-align: center">ពិនិត្យដោយ</div>
            </td>
          </tr>
          <tr>
            <td>
              <div style="width: 50%; float: left; text-align: center"><b>{{datas.crop_trader_name}}</b></div>
              <div style="width: 50%; float: right; text-align: center"><b>{{datas.review_by_name}}</b></div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
</template>

<style scoped>
  .underline {
    border-bottom: 1.5px dotted;
    padding: 0 15px;
  }
</style>
<script>

import {provider} from "@/service/provider";
import axios from "axios";
import MainMixin from "../../../mixins/mainMixin";

export default {
  mixins: [MainMixin],
  data() {
    return {
      params: {},
      datas: {}
    }
  },

  methods: {
    handleRun() {
      if(Object.keys(this.params).length){
        let vm      = this;
        let url     = provider.baseURL + provider.fetchListRequestDrawdown;
        
        let query  = {
            search: "",
            id: this.params.id,
            crop_trader_id: this.params.crop_trader_id,
            application_no: this.params.application_no,
            offset:0,
            limit: vm.itemsPerPage,
            sort_by: "created_at",
            sort_desc:1,
            from_date: "",
            to_date: "",
        };

        axios.post(url, query, {headers: {Authorization: localStorage.token}}).then(res => {
          if (res.data.response && res.data.response.code === 200) {
            vm.datas = res.data.data[0];
            vm.$nextTick(() => { window.print(); });
            vm.$nextTick(() => { this.$router.back(); });
          }
        }).catch(error => console.log(error));

      }else{
        this.$router.back();
      }
    }
  },
  mounted(){ this.handleRun() },
  created() { 
    this.params = this.$route.params;
  }
}
</script>